export enum ReservationDetailsTabType {
    COMMUNICATION = 'COMMUNICATION',
    REFERRAL = 'REFERRAL',
    REPORT = 'REPORT',
    STATUS = 'STATUS',
}
